import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';
import type { CampoApi } from '@/services/Relatorios';
import { SortableItem } from './SortableItem';

interface ColunaListaProps {
  titulo: string;
  campos: CampoApi[];
  isVisivel?: boolean;
  selectedItems?: Set<number>;
  onToggleSelection?: (id: number) => void;
  droppableId?: string;
}

export function ColunaLista({
  titulo,
  campos,
  isVisivel = false,
  selectedItems = new Set(),
  onToggleSelection = () => {},
  droppableId,
}: ColunaListaProps) {
  const { isOver, setNodeRef } = useDroppable({
    id: droppableId || titulo,
  });

  return (
    <div
      className={cn(
        'flex flex-col overflow-hidden rounded-lg border shadow-sm transition-colors',
        isOver && 'bg-primary/5 ring-2 ring-primary'
      )}
    >
      <div className="shrink-0 border-b bg-muted/30 p-4">
        <h3 className="text-base font-semibold">
          {titulo} ({campos.length})
        </h3>
      </div>
      <ScrollArea className="h-full flex-1">
        <div ref={setNodeRef} className="min-h-[200px] space-y-2 p-3">
          <SortableContext
            items={campos.map(campo => campo.Campo_id)}
            strategy={verticalListSortingStrategy}
          >
            {campos.length === 0 ? (
              <div className="flex h-32 items-center justify-center text-sm text-muted-foreground">
                Arraste itens para cá
              </div>
            ) : (
              campos.map((campo, index) => (
                <SortableItem
                  key={campo.Campo_id}
                  campo={campo}
                  index={index}
                  isVisivel={isVisivel}
                  isSelected={selectedItems.has(campo.Campo_id)}
                  onToggleSelection={onToggleSelection}
                />
              ))
            )}
          </SortableContext>
        </div>
      </ScrollArea>
    </div>
  );
}
